import { render, staticRenderFns } from "./RewardsGetHelp.vue?vue&type=template&id=7b4bbd00&scoped=true"
import script from "./RewardsGetHelp.vue?vue&type=script&lang=ts&setup=true"
export * from "./RewardsGetHelp.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./RewardsGetHelp.vue?vue&type=style&index=0&id=7b4bbd00&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4bbd00",
  null
  
)

export default component.exports